export default __webpack_public_path__ + "static/media/4.1329be1c.png";